import { AfterViewInit, Component, ElementRef, OnDestroy, inject } from '@angular/core';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-loader',
  imports: [],
  templateUrl: './loader.component.html',
  styleUrl: './loader.component.scss',
})
export class LoaderComponent implements AfterViewInit, OnDestroy {
  private readonly router = inject(Router);
  private readonly el     = inject(ElementRef);
  private sub?: Subscription;

  ngAfterViewInit(): void {
    const host = this.el.nativeElement as HTMLElement;

    // Si la navegación ya terminó al montar este componente, ocultar de inmediato.
    if (this.router.navigated) {
      host.style.display = 'none';
    }

    this.sub = this.router.events
      .pipe(filter(e =>
        e instanceof NavigationStart  ||
        e instanceof NavigationEnd    ||
        e instanceof NavigationCancel ||
        e instanceof NavigationError
      ))
      .subscribe(e => {
        host.style.display = e instanceof NavigationStart ? '' : 'none';
      });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }
}
